<template>      
    <b-container fluid class="h-100 pt-0 pl-3 pr-3 pb-3 bg-gray-light d-flex flex-column overflow-auto">
        <b-row class="mr-1">
            <Pins :FilterTreeStore="filterTreeStore" :Variant="Variant" :PropertiesFilterPinTypes="propertiesFilterPinTypes" />
        </b-row>
        
        <!-- Selection de la période pour l'export -->
        <b-row class="flex-grow-1 w-100 overflow-auto p-0 m-0">
            <b-col>
                <b-row class="pl-3">
                    <b-col>
                        <h3 class="mt-3">{{ $t('ExportStatementData') }}</h3>
                        <p>{{ $t('ConcerneStart') }}<span class="font-weight-semibold">{{ $t('Meters') }}</span>{{ $t('ConcerneEnd') }}</p>
                    </b-col>
                </b-row>
                <b-row v-if="config.ExportType != exportTypes[ExportType.LAST_STATEMENT]" class="pt- pl-3 pr-3">
                    <b-col>
                        <b-card no-body>
                            <b-card-header class="bg-white border-bottom d-flex align-items-center">
                                <h5 class="mb-0">{{ $t('ExportSettings')}}</h5>
                            </b-card-header>
                            <b-card-body class="bg-white flex-column flex-sm-row">
                                <h6 class="font-weight-semibold">{{ $t('PeriodTitle') }}</h6>
                                <b-row>
                                    <b-col>
                                        <b-form-group :label="$t('StartPeriod')" label-for="startPeriod"
                                                                            label-cols-sm="20"
                                                                            label-class="pt-2 pb-0 pr-0 ml-1">
                                            <DatePicker class="ml-3" id="startPeriod" :Required="true" t="Variant" v-model="config.StartDate" :Locale="$store.getters['SessionStore/GetLanguage']"/>
                                        </b-form-group>
                                    </b-col>
                                    <b-col class="mr-3">
                                        <b-form-group :label="$t('EndPeriod')" label-for="endPeriod"
                                                                            label-cols-sm="20"
                                                                            label-class="pt-2 pb-0 pr-0 ml-1">
                                            <DatePicker class="ml-3 pr-2" id="endPeriod" :Required="true" t="Variant" v-model="config.EndDate" :Locale="$store.getters['SessionStore/GetLanguage']"/>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                            </b-card-body>
                        </b-card>
                    </b-col>
                </b-row>
                <!-- Selection du type d'export -->
                <b-row class="pr-3 pl-3 pt-3">
                    <b-col>
                        <b-card no-body class="bg-white">
                            <b-card-header class="bg-white border-bottom">
                                <h5 class="mb-0">{{ $t('ExportType') }}</h5>
                            </b-card-header>
                            <b-card-body class ="bg-white pt-4" >
                                <b-row class="pt-0 pb-3 pr-4 pl-4" v-for="(value, key) in exportTypes" :key="key">
                                    <b-col>
                                        <b-card @click.stop="exportTypeSwitch(value)" 
                                            :class="['text-danger', {[`border-${Variant}-dark bg-${Variant}-light`]: config.ExportType == value}]"
                                        >
                                            <b-icon icon="record-circle-fill" font-scale="1.3" shift-h="-15" :class="['position-absolute', 'end-0', {invisible: config.ExportType != value}]" :variant="Variant" />
                                            <b-card-text class="font-weight-semibold">{{$t(key.toString())}}</b-card-text>
                                            <b-card-text class="text-muted" style="margin-top: -10px;">{{$t(`${key.toString()}Hint`)}}</b-card-text>
                                        </b-card>
                                    </b-col>
                                </b-row>
                            </b-card-body>
                        </b-card>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
        <b-row class="d-flex justify-content-center mt-3">
            <b-button  @click="exportDatas" pill><b-icon icon="file-earmark-excel"/>   {{ $t('Export')}}</b-button>
        </b-row>
    </b-container>
</template>

<script lang="ts">
    import { Component, Vue, Prop} from 'vue-property-decorator';
    import DatePicker from "@/components/commons/DatePicker.vue";
    import Pins from '@/components/commons/Pins.vue';
    import { API_URL, MAIN_FILTER_TREE } from '@/App.settings';
    import PinTypeEnum from '@/enums/PinTypeEnum';
    import DownloadStateEnum from '@/enums/DownloadStateEnum';
    import Download from '@/types/Download';
    import axios, { AxiosResponse } from 'axios';
    import { Dictionary } from 'vue-router/types/router';
    import locales from './locales/Statements.json';
import EnumItem from '@/types/fields/EnumItem';

    /** A quoi sert ce composant ??!! */
    @Component({
        components: {
            /** Pins de filtrage sur l'arborescence */
            Pins,
            DatePicker
        },
        i18n:{messages: locales}
    })
    export default class Statements extends Vue {
        @Prop({default: () => "secondary"})
        public Variant!: string;

        /**  Instance d'aborescence à utiliser */
        private filterTreeStore: string = MAIN_FILTER_TREE;

        /** Liste des types de Pin pour les filtres par propriétés */
        private propertiesFilterPinTypes: PinTypeEnum[] = [ PinTypeEnum.None, PinTypeEnum.Tree];

        public ExportType = {
            PERIOD: "Period",
            EXCHANGED: "Exchanged",
            RESET: "Reset",
            LAST_STATEMENT : "LastStatement"
        }

        /** Attribut pour stocker l'enum des types d'export */
        private exportTypes: Dictionary<number> = {
            [this.ExportType.PERIOD]: 0,
            [this.ExportType.EXCHANGED]: 1,
            [this.ExportType.RESET]: 2,
            [this.ExportType.LAST_STATEMENT]: 3
        }

        private config = {
            StartDate: new Date(),
            EndDate: new Date(),
            ExportType: 0.
        };

        public exportTypeSwitch(exportType : number) {
            this.config.ExportType = exportType;
        }

        /** Méthode pour charger le mask de l'utilisateur */
        private async createMask() {
            this.$store.dispatch("ShowLoadingMask", this.$t('Loading'));
            let args: Dictionary<any> = {};
            args["Token"] = Vue.cookies.get('access_token') != null ? <string>Vue.cookies.get('access_token') : "";

            await axios.post(API_URL + "Reporting/WorkDocument/Statements/CreateMask", args).then((response) => {
                this.createMaskHandleResponse(response);
            })
            .catch(err => {
               this.createMaskHandleError(err);
            }).finally(() => {this.$store.dispatch("HideLoadingMask", {});});
            
        }

        private createMaskHandleResponse(response: AxiosResponse){
            if (response && response.data) {
                response.data.StartDate = new Date(response.data.StartDate);
                response.data.EndDate = new Date(response.data.EndDate);

                this.config.ExportType = parseInt(response.data.ExportType);
                this.config.StartDate = response.data.StartDate;
                this.config.EndDate = response.data.EndDate;

                console.debug('Statements - LoadMask');
            }
        }

        private createMaskHandleError(err){
            console.error(err);
            this.$bvToast.toast(this.$t('AnErrorOccured').toString(), {
                title: this.$t('Error').toString(),
                autoHideDelay: 10000,
                variant: "danger",
                solid: true,
                appendToast: true,
                toaster: "b-toaster-top-center"
            }); 
        }

        /** Méthode pour sauvegarder le mask de l'utilisateur */
        private async saveMask() {
            let args: Dictionary<any> = {};
            args["Token"] = Vue.cookies.get('access_token') != null ? <string>Vue.cookies.get('access_token') : "";
            args["Parameters"] = this.config ;

            await axios.post(API_URL + "Reporting/WorkDocument/Statements/SaveMask", args).then((response) => {
                if (response && response.data) {
                    console.debug('Statements - SaveMask');
                }
            })
            .catch(err => {
                this.saveMaskHandleError(err);
            });
        }

        private saveMaskHandleError(err : any){
            console.error(err);
            this.$bvToast.toast(this.$t('AnErrorOccured').toString(), {
                title: this.$t('Error').toString(),
                autoHideDelay: 10000,
                variant: "danger",
                solid: true,
                appendToast: true,
                toaster: "b-toaster-top-center"
            });
        }

        /** Méthode d'exportation des données avec différenciation pour que se soit un fichier zip ou un fichier Excel */
        private async exportDatas(){
            if(this.config.ExportType != this.exportTypes[this.ExportType.LAST_STATEMENT] && !this.periodIsValid(new Date(this.config.StartDate), new Date(this.config.EndDate))){
                return;
            }

            if(!this.pinsAreSelected() || !this.exportTypeIsSelected()){
                return;
            }

            let args: Dictionary<any> = {};
            args["Token"] = Vue.cookies.get('access_token') != null ? <string>Vue.cookies.get('access_token') : "";
            args["Mask"] = this.config;

            console.debug(`Start date in mask : ${this.config.StartDate}`)
            console.debug(`Start date in mask : ${args["Mask"].StartDate}`)
            
            args["Pins"] = this.$store.getters[this.filterTreeStore + '/GetPins'];
          

            let index: number = this.$store.getters['DownloadingStore/GetLastIndex'];
            let download: Download = {Index: ++index, Name: "ExportStatements", Type: '', State: DownloadStateEnum.InProgress, Data: "", Direct: true};
            this.$store.dispatch('DownloadingStore/AddDownloading', download);

            this.saveMask();

            this.$store.dispatch("ShowLoadingMask", this.$t('ExportProgress'));

            await axios.post(API_URL + "Reporting/WorkDocument/Statements/Export", args).then((response) => {
                this.exportDatasHandleResponse(response, index)
            })
            .catch(err => {
                this.exportDatasHandleError(err, index);
            }).finally(
                () => this.$store.dispatch("HideLoadingMask", {})
            )
        }

        private exportDatasHandleResponse(response: AxiosResponse, index: number){
            if (response && response.data) {

                const { FileName, ContentType, Content } = response.data;

                if(response.status == 204)
                {
                    this.$bvToast.toast(this.$t('NoExportData').toString(), {
                        title: this.$t('Infos').toString(),
                        autoHideDelay: 10000,
                        variant: "info",
                        solid: true,
                        appendToast: true,
                        toaster: "b-toaster-top-center"
                    });
                    this.$store.dispatch('DownloadingStore/UpdateState', {index, state: DownloadStateEnum.None});
                    return;
                }

                let typeFile = '.xlsx';

                if(ContentType.MediaType === 'application/zip'){
                    typeFile = '.zip';
                }

                const binary = atob(Content);
                const len = binary.length;
                const bytes = new Uint8Array(len);
                for (let i = 0; i < len; i++) bytes[i] = binary.charCodeAt(i);
                const blob = new Blob([bytes], { type: ContentType });

                this.$store.dispatch('DownloadingStore/UpdateName', {index, value: FileName});
                this.$store.dispatch('DownloadingStore/UpdateType', {index, value: typeFile});
                this.$store.dispatch('DownloadingStore/AddData', { index, data: blob });
                this.$store.dispatch('DownloadingStore/UpdateState', {index, state: DownloadStateEnum.Finished});
                return;
            }
            let message = this.$t('AnErrorOccured').toString();
            let variantMessage = "danger";

            if(response.status == 204)
            {
                message = this.$t('NoExportData').toString();
                variantMessage = "info";
            }

            this.$bvToast.toast(message, {
                title: this.$t('Infos').toString(),
                autoHideDelay: 10000,
                variant: variantMessage,
                solid: true,
                appendToast: true,
                toaster: "b-toaster-top-center"
            });
            this.$store.dispatch('DownloadingStore/UpdateState', {index, state: DownloadStateEnum.None});
            return;
        }

        private exportDatasHandleError(err: any, index: number){
            let message = this.$t('AnErrorOccured').toString();
            let variantMessage = "danger";

            if(err)
            {
                message = this.$t(err.response.statusText).toString();
                variantMessage = "info";
            }

            this.$bvToast.toast(message, {
                title: this.$t('Error').toString(),
                autoHideDelay: 10000,
                variant: variantMessage,
                solid: true,
                appendToast: true,
                toaster: "b-toaster-top-center"
            });

            this.$store.dispatch('DownloadingStore/UpdateState', {index, state: DownloadStateEnum.Error});
        }

        /** Méthode vérifiant que la date de fin de la période est supérieur à celle de début*/
        private periodIsValid(startDate: Date, endDate: Date) : boolean {
            if(endDate < startDate) {
                this.$bvToast.toast(this.$t('StartDateBeforeEndDate').toString(), {
                    title: this.$t('Error').toString(),
                    autoHideDelay: 10000,
                    variant: "danger",
                    solid: true,
                    appendToast: true,
                    toaster: "b-toaster-top-center"
                });
                return false;
            }

            return true;
        }

        /** Méthode vérifiant que le type d'export est bien sélectioné */
        private exportTypeIsSelected() : boolean {
            if(!this.config.ExportType && this.config.ExportType != 0) {
                this.$bvToast.toast(this.$t('NoOptionSelected').toString(), {
                    title: this.$t('Error').toString(),
                    autoHideDelay: 10000,
                    variant: "danger",
                    solid: true,
                    appendToast: true,
                    toaster: "b-toaster-top-center"
                });
                return false;
            }

            return true;
        }

        /** Méthode vérifiant que au moins un pin est sélectionné dans l'arbre */
        private pinsAreSelected() : boolean {
            if(this.$store.getters[this.filterTreeStore + '/GetPins'].length === 0) {
                this.$bvToast.toast(this.$t('NoPinSelected').toString(), {
                    title: this.$t('Error').toString(),
                    autoHideDelay: 10000,
                    variant: "danger",
                    solid: true,
                    appendToast: true,
                    toaster: "b-toaster-top-center"
                });
                return false;
            }

            return true;
        }

        async created(){
            await this.createMask();
        }
    }
</script>

<style scoped>
</style>